import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { SettingsBillingCatalogKey } from './settingsBilling.i18n.js';
import { SETTINGS_BILLING_CATALOG } from './settingsBilling.i18n.js';

export type SettingsBillingMessageId = `settingsBilling:${SettingsBillingCatalogKey}`;

const PREFIX_LENGTH = 'settingsBilling:'.length;

/** `t()` for the stop-gap `settingsBilling:` scope (see `settingsBilling.i18n.ts`). */
export function useSettingsBillingT(): { t: (id: SettingsBillingMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: SettingsBillingMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as SettingsBillingCatalogKey;
      const raw = SETTINGS_BILLING_CATALOG[locale][key] ?? SETTINGS_BILLING_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
